import { InputControl, Row, Col } from '@si-armes/dsfr-react';
import React, { useEffect } from 'react';
import InputFiles from 'components/Commun/Form/InputFiles';
import { useFormContext } from 'react-hook-form';
import { getPatternHookFormValidation } from '../../../../../../../utils/utils';
import { REGEXP_NUMERO_GUICHET_UNIQUE } from '../../../../../../../constants/contraintes.constants';

const InformationChasseur = () => {
    const { register, formState, getValues, watch, trigger } = useFormContext();

    const formaterChampsNumeroGuichetUnique = (value) => {
        return value.replace(/\D/g, '');
    };

    useEffect(() => {
        trigger(['validationPermisChasser']);
    }, [watch('numeroGuichetUnique')]);

    return (
        <>
            <Row>
                <Col col={12}>
                    <h3>Informations sur le permis de chasser</h3>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <p>Veuillez renseigner le numéro de votre permis de chasser *</p>
                </Col>
            </Row>

            <Row gutters>
                <Col col={12} lg={6}>
                    <InputControl
                        id="numeroPermisChasseur"
                        name="numeroPermisChasseur"
                        label="Numéro de permis de chasser *"
                        hintText="Veuillez vous rapprocher de la fédération départementale de votre lieu actuel de résidence si vous ne disposez pas d'un numéro de permis de chasser"
                        {...register('numeroPermisChasseur', {
                            required: 'Ce champ est obligatoire',
                        })}
                        uppercase
                        required
                    />
                </Col>
                <Col col={12} lg={6} data-testid="account-creation-step1-permisDeChasse-col">
                    <InputFiles
                        name="permisDeChasse"
                        label="Ajouter mon permis de chasser"
                        error={formState.errors ? formState.errors.permisDeChasse : null}
                        required
                    />
                </Col>
            </Row>

            <Row gutters>
                <Col col={12} lg={6}>
                    <InputControl
                        id="numeroGuichetUnique"
                        name="numeroGuichetUnique"
                        label="Numéro de guichet unique de votre validation en cours"
                        {...register('numeroGuichetUnique', {
                            pattern: getPatternHookFormValidation(
                                REGEXP_NUMERO_GUICHET_UNIQUE,
                                'numero guichet unique',
                                'Veuillez renseigner a minima 14 caractères',
                            ),
                        })}
                        state={formState.errors?.numeroGuichetUnique ? 'error' : null}
                        message={formState.errors?.numeroGuichetUnique?.message}
                        maskFonction={formaterChampsNumeroGuichetUnique}
                        minLength="14"
                        hintText="Ce champ n'est pas obligatoire. Le numéro de guichet unique de la validation de permis de chasser de la fédération nationale des chasseurs est constitué de 14 chiffres."
                    />
                </Col>
                <Col col={12} lg={6}>
                    <InputFiles
                        label="Ajouter ma validation de permis de chasser"
                        id="validationPermisChasser"
                        name="validationPermisChasser"
                        error={formState.errors ? formState.errors.validationPermisChasser : null}
                        required={getValues('numeroGuichetUnique')}
                        disabled={!getValues('numeroGuichetUnique')}
                    />
                </Col>
            </Row>
        </>
    );
};

export default InformationChasseur;
